import { useEffect, useRef } from 'react';

const TelegramLoginWidget = ({
  botName = 'r77_staging_bot',
  buttonSize = 'medium',
  authUrl = '',
  requestAccess = 'write'
}) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.setAttribute('data-telegram-login', botName);
    script.setAttribute('data-size', buttonSize);
    script.setAttribute('data-auth-url', authUrl);
    script.setAttribute('data-request-access', requestAccess);
    script.async = true;

    containerRef.current?.appendChild(script);

    return () => {
      if (containerRef.current) {
        containerRef.current.innerHTML = '';
      }
    };
  }, [botName, buttonSize, authUrl, requestAccess]);

  return <div ref={containerRef} />;
};

export default TelegramLoginWidget;
